import type { IComment } from "../../types/comment";

// Updates the likes on the comments on an image //
export const updateCommentLikes = (comments: IComment[], username: string, commentId: string) => {
    const comment = comments.filter((comment: IComment) => comment._id === commentId)[0];
    const alreadyLiked = comment.likes.includes(username);

    let newLikes = comment.likes;

    if (!alreadyLiked) {
        newLikes = [...newLikes, username];
    } else if (alreadyLiked) {
        newLikes = newLikes.filter((u) => u !== username);
    }

    return comments.map((comment: IComment) => {
        if (comment._id !== commentId) return comment;

        return { ...comment, likes: newLikes };
    });
};
